/** 启用停用状态 */
export enum TStatus {
  Enable = 'enable',
  Disable = 'disable'
}
/** 退款类型 */
export enum TRefundType {
  /** 手机退款 */
  MobileRefund = 'mobileRefund'
}
